import { BrowserRouter, Routes, Route, NavLink, Navigate } from 'react-router-dom'
import {
  DollarSign, Camera, ThumbsUp, Video, PlayCircle,
  Mail, CheckSquare, Users, BarChart2, Repeat,
  Lock, FlaskConical
} from 'lucide-react'
import './App.css'

// Tab imports
import Revenue     from './tabs/Revenue'
import TabStub     from './tabs/TabStub'

const NAV = [
  { to: '/',              label: 'Revenue',          Icon: DollarSign,  exact: true },
  { to: '/instagram',     label: 'Instagram',        Icon: Camera     },
  { to: '/facebook',      label: 'Facebook',         Icon: ThumbsUp   },
  { to: '/tiktok',        label: 'TikTok',           Icon: Video      },
  { to: '/youtube',       label: 'YouTube',          Icon: PlayCircle },
  { to: '/email',         label: 'Email Metrics',    Icon: Mail       },
  { to: '/operations',    label: 'Operations',       Icon: CheckSquare},
  { to: '/event-attend',  label: 'Live Attendance',  Icon: Users      },
  { to: '/event-roas',    label: 'Live ROAS & Sales', Icon: BarChart2  },
  { to: '/evergreen',     label: 'Evergreen',        Icon: Repeat     },
  { to: '/strategic',     label: 'Strategic',        Icon: Lock       },
  { to: '/ad-tests',      label: 'Ad Tests',         Icon: FlaskConical},
]

export default function App() {
  return (
    <BrowserRouter>
      <div className="app-shell">
        <aside className="sidebar">
          <div className="sidebar-logo">
            <span className="logo-text">IFIO</span>
            <span className="logo-sub">Dashboard</span>
          </div>
          <nav className="sidebar-nav">
            {NAV.map(({ to, label, Icon, exact }) => (
              <NavLink
                key={to}
                to={to}
                end={exact}
                className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
              >
                <Icon size={16} strokeWidth={2} />
                <span>{label}</span>
              </NavLink>
            ))}
          </nav>
          <div className="sidebar-footer">
            <span className="text-muted" style={{ fontSize: 11 }}>v1.0 · Phase 1</span>
          </div>
        </aside>

        <main className="main-content">
          <Routes>
            <Route path="/"             element={<Revenue />} />
            <Route path="/instagram"    element={<TabStub name="Instagram" />} />
            <Route path="/facebook"     element={<TabStub name="Facebook" />} />
            <Route path="/tiktok"       element={<TabStub name="TikTok" />} />
            <Route path="/youtube"      element={<TabStub name="YouTube" />} />
            <Route path="/email"        element={<TabStub name="Email Metrics" />} />
            <Route path="/operations"   element={<TabStub name="Operations" />} />
            <Route path="/event-attend" element={<TabStub name="Live Event Attendance" />} />
            <Route path="/event-roas"   element={<TabStub name="Live Event ROAS & Sales" />} />
            <Route path="/evergreen"    element={<TabStub name="Evergreen Metrics & Sales" />} />
            <Route path="/strategic"    element={<TabStub name="Strategic" />} />
            <Route path="/ad-tests"     element={<TabStub name="Facebook Ad Tests" />} />
            <Route path="*"             element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  )
}
